import { render } from "./appPageTopic.vue?vue&type=template&id=2550cf4a&scoped=true"
import script from "./appPageTopic.vue?vue&type=script&lang=js"
export * from "./appPageTopic.vue?vue&type=script&lang=js"

import "./appPageTopic.vue?vue&type=style&index=0&id=2550cf4a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2550cf4a"]])

export default __exports__